import { render, staticRenderFns } from "./RecursiveIndent.vue?vue&type=template&id=aef7ec34&scoped=true&"
import script from "./RecursiveIndent.vue?vue&type=script&lang=js&"
export * from "./RecursiveIndent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef7ec34",
  null
  
)

export default component.exports